module.exports = __webpack_public_path__ + "img/未标题-3-05.12ecbca5.png";